import { ButtonType } from '@/lib/models/components/buttonLink.types'
import { IconType } from '@/lib/ui-kit/components/ui/Icon.types'

import { ButtonIconText } from './ButtonIconText.component'

interface ButtonLinkExternalProps {
  children: React.ReactNode
  linkUrl: string
  className?: string
  buttonType?: ButtonType
  anchorClassName?: string
  noIcon?: boolean
}

export const ButtonLinkExternal = ({
  children,
  linkUrl: href,
  className,
  anchorClassName,
  buttonType = ButtonType.SECONDARY,
  noIcon,
}: ButtonLinkExternalProps) => {
  return (
    <a href={href} className={anchorClassName} target="_blank">
      <ButtonIconText
        className={className}
        iconType={IconType.arrow_right_skew}
        variant={buttonType}
        noIcon={noIcon}
      >
        {children}
      </ButtonIconText>
    </a>
  )
}
